import { useState, useEffect } from 'react';

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (!dismissed) setVisible(window.scrollY > window.innerHeight * 0.6);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [dismissed]);

  // FloatingCTA 노출 여부를 body 클래스로 반영 → CSS에서 vapi-widget 위치 제어
  useEffect(() => {
    if (visible && !dismissed) {
      document.body.classList.add('floating-cta-active');
    } else {
      document.body.classList.remove('floating-cta-active');
    }
    return () => document.body.classList.remove('floating-cta-active');
  }, [visible, dismissed]);

  if (!visible || dismissed) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[90] bg-[#07091A]/97 backdrop-blur-xl border-t border-neon/15"
      style={{ boxShadow: '0 -4px 30px rgba(0,255,135,0.07)' }}
    >
      {/* Mobile layout */}
      <div className="md:hidden px-4 py-2.5 flex items-center gap-2">
        <div className="flex items-center gap-1.5 flex-shrink-0">
          <span className="text-neon font-black text-sm leading-none">0원</span>
          <span className="text-white/35 text-xs">상담</span>
          <span className="text-white/15 text-xs mx-0.5">·</span>
          <span className="text-white/50 text-xs whitespace-nowrap">광고 진단</span>
        </div>
        <button
          onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
          className="flex-1 flex items-center justify-center gap-1.5 bg-neon hover:bg-neon-dim text-navy font-black px-4 py-2.5 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap text-xs"
        >
          무료로 진단 받기
          <i className="ri-arrow-right-line text-xs"></i>
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="flex-shrink-0 w-7 h-7 flex items-center justify-center text-white/25 hover:text-white/60 cursor-pointer"
        >
          <i className="ri-close-line text-sm"></i>
        </button>
      </div>

      {/* Desktop layout */}
      <div className="hidden md:flex max-w-6xl mx-auto px-8 py-3.5 items-center justify-between gap-6">
        {/* Left: offer */}
        <div className="flex items-center gap-8 flex-1">
          <div className="flex items-center gap-2.5 bg-neon/10 border border-neon/20 rounded-xl px-5 py-2.5 flex-shrink-0">
            <span className="text-neon font-black text-xl font-display leading-none">0원</span>
            <span className="text-white/40 text-xs leading-tight">상담<br />비용</span>
          </div>

          <div className="w-px h-8 bg-white/10 flex-shrink-0"></div>

          <div className="flex items-center gap-10">
            {[
              { val: '4.8억 → 20.1억', sub: '4개월 성과' },
              { val: 'ROAS 12배', sub: '평균 수익' },
              { val: '350+', sub: '성공 사례' },
            ].map((s, i, arr) => (
              <div key={i} className="flex items-center gap-10">
                <div className="text-center">
                  <div className="text-neon font-black text-sm font-display leading-none whitespace-nowrap">{s.val}</div>
                  <div className="text-white/30 text-xs mt-1">{s.sub}</div>
                </div>
                {i < arr.length - 1 && (
                  <div className="w-px h-7 bg-white/10"></div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Right: CTA */}
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="flex items-center gap-2 bg-neon hover:bg-neon-dim text-navy font-black px-7 py-3 rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
          >
            지금 무료로 광고 진단 받기 →
          </button>
          <button
            onClick={() => setDismissed(true)}
            className="w-8 h-8 flex items-center justify-center text-white/20 hover:text-white/50 cursor-pointer"
          >
            <i className="ri-close-line text-base"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
